import { ajaxSend } from 'api/api';

import {
  BanIpPayload,
  BanIpResponse,
  BanQueryOptions,
  BansByIpResponse,
  BansByUserResponse,
  BanUserPayload,
  BanUserResponse,
  IpAddress,
  UnbanIpPayload,
  UnbanIpResponse,
  UnbanUserPayload,
  UnbanUserResponse,
  UserActiveBansResponse,
} from './types';

const BANS_API_BASE = '/v1/bans';
const USERS_API_BASE = `${BANS_API_BASE}/user`;
const IP_API_BASE = `${BANS_API_BASE}/ip`;
const BANS_GROUPED_API_BASE = `${BANS_API_BASE}/users/grouped`;

class BansApi {
  public getUserBan(userId: string) {
    return ajaxSend<UserActiveBansResponse>({
      path: `${USERS_API_BASE}/${userId}`,
    });
  }

  public getBansByUser({
    params = {},
    path = `${BANS_GROUPED_API_BASE}/user`,
  }: BanQueryOptions) {
    return ajaxSend<BansByUserResponse>({
      path,
      params,
    });
  }

  public getBansByIp({
    params = {},
    path = `${BANS_GROUPED_API_BASE}/ip`,
  }: BanQueryOptions) {
    return ajaxSend<BansByIpResponse>({
      path,
      params,
    });
  }

  /**
   * Bans a user from a channel.
   *
   * @param userId The id of the user to ban.
   * @param data The users ban data.
   */
  public banUser(userId: string, data: BanUserPayload) {
    return ajaxSend<BanUserResponse>({
      path: `${USERS_API_BASE}/${userId}/ban`,
      method: 'PATCH',
      data,
    });
  }

  /**
   * Bans the ip address.
   *
   * @param ipAddress The ip address to ban.
   * @param data The ip ban data.
   */
  public banIp(ipAddress: IpAddress, data: BanIpPayload = {}) {
    return ajaxSend<BanIpResponse>({
      path: `${IP_API_BASE}/${ipAddress}/ban`,
      method: 'PATCH',
      data,
    });
  }

  /**
   * Unbans the user from a channel.
   *
   * @param userId The id of the user to unban.
   * @param data The users unban data.
   */
  public unbanUser(userId: string, data: UnbanUserPayload) {
    return ajaxSend<UnbanUserResponse>({
      path: `${USERS_API_BASE}/${userId}/unban`,
      method: 'PATCH',
      data,
    });
  }

  /**
   * Unbans the ip address.
   *
   * @param ipAddress The ip address to unban.
   * @param data The ip unban data.
   */
  public unbanIp(ipAddress: IpAddress, data: UnbanIpPayload = {}) {
    return ajaxSend<UnbanIpResponse>({
      path: `${IP_API_BASE}/${ipAddress}/unban`,
      method: 'PATCH',
      data,
    });
  }
}

export const bansApi = new BansApi();
